import api  from '../../services/api';
import * as docparser from '../../services/docparserSvc'
import * as type from '../types';
import moment from 'moment';
import _ from 'lodash';

export default {
    namespaced: true,
    state: {
        headers: [
            { text: 'Date Imported', value: 'uploaded_at', sortable: true, formatter: (row) => moment(row.uploaded_at).utcOffset('+08:00').format('MM/DD/YYYY, hh:mm A'), width: '160' },
            { text: 'Batch ID', value: 'batch_id', sortable: true, width: '150' },
            { text: 'Parser', value: 'parser_name', sortable: true },
            { text: 'Parser Type', value: 'parser_type', sortable: true,  width: '130' },
            { text: 'Username', value: 'curr_user', sortable: true, width: '150' },
            { text: 'Total Page', value: 'total_page', sortable: true, width: '120' },
            { text: 'Status', value: 'status', sortable: true, formatter: (row) => row.status === 0 ? 'Queued' : row.status === 1 ? 'Parsing' : row.status === 2 ? 'Completed' : '', width: '100' },
            { text: 'Actions', value: '', align: 'center', alignHeader: 'center', width: '160' }
        ],
        parsedResultHeaders: [
            { text: '', type: 'selection', width: '55',  align: 'center', alignHeader: 'center' },
            { text: 'Order Confirmation No.', value: 'oc_number', sortable: true },
            { text: 'Invoice No.', value: 'invoice_number', sortable: true },
            { text: 'Invoice Date', value: 'invoice_date', sortable: true },
            { text: 'PO No.', value: 'po_number', sortable: true },
            { text: 'PO Date', value: 'po_date', sortable: true },
            { text: 'Terms', value: 'terms', sortable: true },
            { text: 'Carrier', value: 'carrier', sortable: true },
            { text: 'Discount', value: 'discount', sortable: true },
            { text: 'Total Sub Price', value: 'total_sub_price', sortable: true },
            { text: 'Total Price', value: 'total_price', sortable: true },
            { text: 'Actions', value: '', align: 'center', alignHeader: 'center' }
        ],
        items: [],
        itemsByBatchId: [],
        itemsByInvoice: [],
        parsers: [],
        loading: false,
        importLoading: false,
        parsedDataLoading: false,

        filterParsers: [],
        filterUsername: [],
        filterStatus: []
    },
    getters: {
        headers: state => state.headers,
        parsedResultHeaders: state => state.parsedResultHeaders,
        items: state => state.items,
        itemsByBatchId: state => state.itemsByBatchId,
        itemsByInvoice: state => state.itemsByInvoice,
        parsers: state => state.parsers,
        getLoading: state => state.loading,
        getImportLoading: state => state.importLoading,
        getParsedDataLoading: state => state.parsedDataLoading,

        getFilterParsers: state => state.filterParsers,
        getFilterUsername: state => state.filterUsername,
        getFilterStatus: state => state.filterStatus
    },
    mutations: {
        setLoading: (state, payload) => state.loading = payload,
        setImportLoading: (state, payload) => state.importLoading = payload,
        setParsedDataLoading: (state, payload) => state.parsedDataLoading = payload,
        setParsedResultHeaders: (state, payload) => state.parsedResultHeaders = payload,
        [type.DP_GET_FILTER_OPTIONS]: (state, payload) => {
            if(payload.field === 'parser_name'){
                state.filterParsers = payload.data
            }else if(payload.field === 'curr_user'){
                state.filterUsername = payload.data
            }else if(payload.field === 'status'){
                state.filterStatus = payload.data
            }
        },
        [type.DP_GET_PARSERS]: (state, payload) => state.parsers = payload,
        [type.DP_UPDATE_PARSER_NOTE_BY_ID]: (state, payload) => {
            for(let x in state.parsers){
                let data = state.parsers[x];
                if(data.id === payload.id){
                    data.notes = payload.notes;
                }
            }
        },
        [type.DP_ADD_PARSED_RESULT]: (state, payload) => state.items.unshift(payload),
        [type.DP_GET_PARSED_RESULT]: (state, payload) => state.items = payload,
        [type.DP_GET_PARSED_RESULT_BY_BATCHID]: (state, payload) => state.itemsByBatchId = payload,
        [type.DP_GET_PARSED_DATA_BY_ID]: (state, payload) => state.itemsByInvoice = payload,
    },
    actions: {
        [type.DP_GET_FILTER_OPTIONS]: async ({commit}, payload) => {
            try {
                const { table, field } = payload;
                const response = await api.get(`/docparser/import-logs/query?table=${table}&field=${field}`);
                if(response.data){
                    let data = response.data.map(e => e[field])
                    commit(type.DP_GET_FILTER_OPTIONS, { field, data })
                }
            } catch (error) {
                console.log(error)
            }
        },
        [type.DP_GET_PARSERS]: async ({commit}) => {
            try {
                // let dbParsers = await api.get('/docparser/parsers');
                // let dpParsers = await docparser.getParsers();
                // let newParsers = [];

                // for (const dpParser of dpParsers) {
                //     let result = await dbParsers.data.some(e => e.parser_id === dpParser.id);
                //     if(!result){
                //         newParsers.push(dpParser)
                //     }
                // }
                // if(newParsers.length > 0) await api.post('/docparser/parsers', { parsers: newParsers });

                let response = await api.get('/docparser/parsers');
                commit(type.DP_GET_PARSERS, response.data)
            } catch (error) {
                commit(`global/${type.SET_NOTIFICATION}`, { type: 'error', message: error.data.err.msg || error }, { root: true });
            }
        },
        [type.DP_UPDATE_PARSER_NOTE_BY_ID]: async ({commit},payload) => {
            try {
                let response = await api.put(`/docparser/parsers/${payload.id}`, { notes: payload.notes });
                if(response.status === 200){
                    commit(type.DP_UPDATE_PARSER_NOTE_BY_ID, payload)
                    commit(`global/${type.SET_NOTIFICATION}`, { type: 'success', message: response.data.message }, { root: true });
                }
            } catch (error) {
                commit(`global/${type.SET_NOTIFICATION}`, { type: 'error', message: error.data.err.msg }, { root: true });
            }
        },
        [type.DP_ADD_PARSED_RESULT]: async ({commit}, payload) => {
            commit('setImportLoading', true);
            try {
                const { filename, myFile, parserId, userName } = payload;
                const batchId = `DP-${Date.now()}`; 

                //1. Upload PDF and GET the filelink
                let uploadFormData = new FormData();
                uploadFormData.append('myFile', myFile)
                let importResponse = await api.post('/file/upload',uploadFormData, { headers: { "Content-Type":"application/pdf" } } );

                //2. Import PDF to docparser
                await docparser.importDocumentByUrl({ parser_id: parserId, url: importResponse.data.fileLocation, remote_id: batchId });

                //3. import the data to database
                let data = {
                    batchId,
                    parserId,
                    userName,
                    originalFilename: filename,
                    fileLink: importResponse.data.fileLocation
                }
                let dbResponse = await api.post('/docparser/parsed-result', JSON.stringify(data));
                
                commit(type.DP_ADD_PARSED_RESULT, dbResponse.data.result);
                commit(`global/${type.SET_NOTIFICATION}`, { type: 'success', message: dbResponse.data.message }, { root: true });
                return Promise.resolve();
            } catch (error) {
                commit(`global/${type.SET_NOTIFICATION}`, { type: 'error', message: error.data.err.msg }, { root: true });
            }finally{
                commit('setImportLoading', false);
            }
        },
        [type.DP_GET_PARSED_RESULT]: async({commit}, payload) => {
            commit('setLoading', true);
            try {
                const { startDate, endDate, userName, parserId, parserName, status } = payload;
                let query = '';
                if(startDate && endDate){ query = query ? `${query}&startDate=${startDate}&endDate=${endDate}` : `startDate=${startDate}&endDate=${endDate}` }
                if(userName){ query = query ? `${query}&userName=${userName}` : `userName=${userName}` }
                if(parserId){ query = query ? `${query}&parserId=${parserId}` : `parserId=${parserId}` }
                if(parserName){ query = query ? `${query}&parserName=${parserName}` : `parserName=${parserName}` }
                if(status){ query = query ? `${query}&status=${status}` : `status=${status}` }

                let dbParsedResults = await api.get(`/docparser/parsed-result?${query}`);

                if(dbParsedResults.data.length === 0){
                    commit(type.DP_GET_PARSED_RESULT, [])
                }else{
                    let data = [];
                    let parsedResult = dbParsedResults.data;
                    
                    async function recursive(index, items){
                        if(index+1 === items.length){
                            commit(type.DP_GET_PARSED_RESULT, data);
                        }else{
                            let item = items[index];

                            if(item.status === 1){
                                let dpProgressResult = await docparser.getParsedDataByRemoteId({ parser_id: item.parser_id, remote_id: item.batch_id });
                                
                                if (dpProgressResult[0].processed_at === undefined || dpProgressResult[0].processed_at == null) {
                                    data.push(item)
                                    console.log('ongoing:',item);
                                }else{
                                    await api.post('/docparser/parsed-data', { batchId: item.batch_id, values: dpProgressResult });
                                    await api.put(`/docparser/parsed-result/${item.id}`, JSON.stringify({ totalPage: dpProgressResult.length, status: 2  }));
                                    data.push({ ...item, total_page: dpProgressResult.length, status: 2 });
                                }
                            }else{ 
                                data.push(item)
                            }

                            await recursive(index+1, items)
                        }
                    }
                    await recursive(0, parsedResult)
                }
            } catch (error) {
                console.log(error)
                commit(`global/${type.SET_NOTIFICATION}`, { type: 'error', message: error.data.err.msg }, { root: true });
            }finally{
                commit('setLoading', false);
            }
        },
        [type.DP_GET_PARSED_RESULT_BY_BATCHID]: async ({commit, getters }, payload) => {
            commit(`global/${type.SET_LOADING}`, null, { root: true });
            try {
                let response = await api.get(`/docparser/parsed-data?batch_id=${payload.batchId}&all_data=true`);
                
                let newParseResultHeaders = payload.parserType === 'Invoice' ? getters.parsedResultHeaders.filter(e => e.value !== "oc_number") : getters.parsedResultHeaders.filter(e => e.value !== "invoice_number" && e.value !== "invoice_date")
                
                let exportData = [];
                response.data.forEach(data => {
                    let invoiceItems = data.invoice_items;
                    for(let item in invoiceItems){
                        exportData.push({
                            ...data,
                            ...invoiceItems[item]
                        })
                    }
                });
                let itemsHeader = _.sortBy(Object.keys(response.data[0].invoice_items[0]).map(key => {
                    return {
                        text: _.startCase(key),
                        value: key,
                        sortable: true
                    }
                }),['text']).map(e => ({ label: e.text, field: e.value }))
                let dataHeader = newParseResultHeaders.map(e => ({ label: e.text, field: e.value })).filter(e => e.label !== '' && e.label !== 'Actions')
                let exportHeader = [...dataHeader, ...itemsHeader];

                commit(type.DP_GET_PARSED_RESULT_BY_BATCHID, response.data);
                return Promise.resolve({headers: newParseResultHeaders, exportData, exportHeader });
            } catch (error) {
                console.log(error);
                commit(`global/${type.SET_NOTIFICATION}`, { type: 'error', message: error.data.err.msg }, { root: true });
            }finally{
                commit(`global/${type.REMOVE_LOADING}`, null, { root: true }); 
            }
        },
        [type.DP_GET_PARSED_DATA_BY_ID]: async ({commit}, payload) => {
            commit('setParsedDataLoading', true);
            try {
                let response = await api.get(`/docparser/parsed-data/${payload}`);
                commit(type.DP_GET_PARSED_DATA_BY_ID, response.data)
                if(response.data[0].invoice_items.length > 0){
                    let keyHeaders = Object.keys(response.data[0].invoice_items[0]);
                    let headers = _.sortBy(keyHeaders.map(key => {
                        return {
                            text: _.startCase(key),
                            value: key,
                            sortable: true
                        }
                    }),['text'])
                    let exportHeaders = headers.map(e => ({ label: e.text, field: e.value }));
                    return Promise.resolve({
                        headers,
                        items: response.data[0].invoice_items,
                        exportHeaders
                    })
                }else{
                    commit(`global/${type.SET_NOTIFICATION}`, { type: 'error', message: "No invoice items found!" }, { root: true });
                }
                commit('setParsedDataLoading', false);
            } catch (error) {
                commit(`global/${type.SET_NOTIFICATION}`, { type: 'error', message: error.data.err.msg }, { root: true });
                commit('setParsedDataLoading', false);
                return Promise.reject(error)
            }
        }
    }
}